module.exports = __webpack_public_path__ + "static/media/126.33c9adf5.png";